"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var React = tslib_1.__importStar(require("react"));
//@ts-ignore
var Collapse_1 = tslib_1.__importDefault(require("@mui/material/Collapse"));
var Collapse = function (_a) {
    var children = _a.children, visibled = _a.visibled, _b = _a.destroyOnClose, destroyOnClose = _b === void 0 ? false : _b, onEnter = _a.onEnter, onClose = _a.onClose, _c = _a.mountOnEnter, mountOnEnter = _c === void 0 ? false : _c, _d = _a.timeout, timeout = _d === void 0 ? 500 : _d, id = _a.id;
    return ((0, jsx_runtime_1.jsx)(Collapse_1.default, tslib_1.__assign({ id: id, in: visibled, timeout: timeout, unmountOnExit: destroyOnClose, onEnter: onEnter, onExited: onClose, mountOnEnter: mountOnEnter }, { children: children })));
};
/**
 * @deprecated Use Collapse from Antd
 * https://ant.design/components/collapse/
 */
exports.default = React.memo(Collapse);
